import { createSlice } from '@reduxjs/toolkit'
import {
  betListBlackjackGame, getBlackJackHighRollerTransactions, getBlackJackTransactions,
  getMyBlackJackTransactions, unfinishedBetBlackjackGame
} from 'games/BlackjackGame/slice-thunk/blackjack.thunk'

const initialState = {
  loading: false,
  betsLoading: false,
  betList: null,
  unFinishedBet: null,
  blackjackTransactions: null,
  myBlackjackTransactions: null,
  blackjackHighRollerTransactions: null,
  wins: 0,
  losses: 0,
  profit: 0,
  wagered: 0,
  resultState: {
    result: null,
    amount: null,
    isCardSplittingCompleted: false
  }
}

const {
  actions: {
    resetUnfinishedBet,
    setUpdateMyBet,
    setBlackjack,
    setBlackjackGameWins,
    setBlackjackGameLosses,
    setBlackjackGameProfit,
    setBlackjackGameWagered,
    resetLiveStats,
    setWinningState,
    resetWinningState
  },
  reducer
} = createSlice({
  name: 'blackjack',
  initialState,
  reducers: {
    resetUnfinishedBet: (state, action) => ({
      ...state,
      unFinishedBet: null
    }),
    setUpdateMyBet: (state, action) => {
      return ({
        ...state,
        myBlackjackTransactions: action.payload
      })
    },
    setBlackjackGameWins: (state, action) => {
      if (action.payload) {
        return {
          ...state,
          wins: action.payload.reset
        }
      }
      return {
        ...state,
        wins: state.wins + 1
      }
    },
    setBlackjackGameLosses: (state, action) => {
      if (action.payload) {
        return {
          ...state,
          losses: action.payload.reset
        }
      }
      return {
        ...state,
        losses: state.losses + 1
      }
    },
    setBlackjackGameProfit: (state, action) => {
      return {
        ...state,
        profit: (+state.profit + +(action.payload).toFixed(2))
      }
    },
    setBlackjackGameWagered: (state, action) => {
      return {
        ...state,
        wagered: (+state.wagered + +(action.payload).toFixed(2))
      }
    },
    resetLiveStats: (state, action) => {
      return {
        ...state,
        wins: 0,
        losses: 0,
        profit: 0,
        wagered: 0
      }
    },
    setWinningState: (state, action) => {
      return {
        ...state,
        resultState: {
          ...state.resultState,
          ...action.payload
        }
      }
    },
    resetWinningState: (state, action) => {
      return {
        ...state,
        resultState: initialState.resultState
      }
    }
  },
  extraReducers: builder => {
    builder
      .addCase(betListBlackjackGame.fulfilled, (state, { payload }) => ({
        ...state,
        betList: payload
      }))
      .addCase(unfinishedBetBlackjackGame.fulfilled, (state, { payload }) => ({
        ...state,
        unFinishedBet: payload
      }))
      .addCase(getBlackJackTransactions.pending, (state, action) => {
        return {
          ...state,
          betsLoading: true
        }
      })
      .addCase(getBlackJackTransactions.fulfilled, (state, action) => {
        return {
          ...state,
          blackjackTransactions: action?.payload,
          betsLoading: false
        }
      })
      .addCase(getBlackJackTransactions.rejected, (state, action) => {
        return {
          ...state,
          betsLoading: false
        }
      })
      .addCase(getMyBlackJackTransactions.pending, (state, action) => {
        return {
          ...state,
          betsLoading: true
        }
      })
      .addCase(getMyBlackJackTransactions.fulfilled, (state, action) => {
        return {
          ...state,
          myBlackjackTransactions: action?.payload,
          betsLoading: false
        }
      })
      .addCase(getMyBlackJackTransactions.rejected, (state, action) => {
        return {
          ...state,
          betsLoading: false
        }
      })
      .addCase(getBlackJackHighRollerTransactions.pending, (state, action) => {
        return {
          ...state,
          betsLoading: true
        }
      })
      .addCase(getBlackJackHighRollerTransactions.fulfilled, (state, action) => {
        return {
          ...state,
          blackjackHighRollerTransactions: action?.payload,
          betsLoading: false
        }
      })
      .addCase(getBlackJackHighRollerTransactions.rejected, (state, action) => {
        return {
          ...state,
          betsLoading: false
        }
      })
  }
})

export {
  resetUnfinishedBet, setUpdateMyBet, setBlackjackGameWins, setBlackjackGameWagered,
  setBlackjackGameLosses, setBlackjackGameProfit, setBlackjack, resetLiveStats, setWinningState,
  resetWinningState
}

export default reducer
